import script from "./CheckoutSkeletonLine.vue?vue&type=script&setup=true&lang=ts"
export * from "./CheckoutSkeletonLine.vue?vue&type=script&setup=true&lang=ts"

import "./CheckoutSkeletonLine.vue?vue&type=style&index=0&id=0d044699&lang=less&scoped=true"

import exportComponent from "D:\\a\\1\\s\\src\\Bolia.Website\\clients\\app\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-0d044699"]])

export default __exports__